// extracted by mini-css-extract-plugin
export default {"statusBanner":"HcGVWMK4CKOo7vGPi5Yh"};